import { SxProps, Theme } from "@mui/system";
import {
  DatePicker,
  DatePickerSlotsComponentsProps,
  DateView,
} from "@mui/x-date-pickers";
import { type Moment } from "moment";
import { useState } from "react";

export type DayPickerProps = {
  value: Moment | null;
  label?: string;
  views?: readonly DateView[];
  openTo?: DateView;
  sx?: SxProps<Theme>;
  slotProps?: DatePickerSlotsComponentsProps<Moment>;
  format?: string;
  readOnly?: boolean;
  disabled?: boolean;
  minDate?: Moment;
  maxDate?: Moment;
  onUpdate?: (e: Moment | null) => void;
};

export function DayPicker(props: DayPickerProps) {
  const [localValue, setLocalValue] = useState<Moment | null>(props.value);

  return (
    <DatePicker
      value={props.value}
      label={props.label}
      views={props.views}
      openTo={props.openTo}
      format={props.format}
      readOnly={props.readOnly}
      disabled={props.disabled}
      minDate={props.minDate}
      maxDate={props.maxDate}
      sx={props.sx}
      slotProps={{
        ...props.slotProps,
        field: {
          ...props.slotProps?.field,
          onBlur: () => {
            if (
              !!props.onUpdate &&
              !!localValue &&
              !localValue.isSame(props.value)
            ) {
              props.onUpdate(localValue);
            }
          },
          onKeyDown: (e) => {
            if (
              e.key === "Enter" &&
              !!props.onUpdate &&
              !!localValue &&
              !localValue.isSame(props.value)
            ) {
              props.onUpdate(localValue);
            }
          },
        },
      }}
      onAccept={props.onUpdate}
      onChange={setLocalValue}
    />
  );
}
